import React from "react"
import { Centered } from "../common/centered/Centered"
import { AppLink } from "../common/link/AppLink"
import ok from '../../assets/icons/ok.png'
import styles from './Finish.module.css'
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { resetStateAC } from "../../store/actions/builderActions"

export const Finish = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const onFinishHandler = () => {
        dispatch(resetStateAC())
        navigate('/')
    }
    return <Centered>
        <div>Your song successfully uploaded!</div>
        <img src={ok} className={styles.image} />
        <AppLink action={onFinishHandler}>Finish</AppLink>
    </Centered>
}